import { Button } from "@material-ui/core";
import React from "react";
import { IEditorState } from "../..";
import { connect } from "react-redux";

export interface ISaveProps {
    hasUnsavedChanges: boolean;

    onSave: () => void;

    onExit: () => void;
}

class SaveComponent extends React.Component<ISaveProps> {

    public render() {
        return (
            <div style={{ placeSelf: "center flex-end" }}>
                <Button variant="contained" size="small" color="primary" disabled={!this.props.hasUnsavedChanges} style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }} onClick={this.props.onSave}>
                    Save
                </Button>
                <Button variant="contained" size="small" color="primary" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} onClick={this.props.onExit}>
                    Exit
                </Button>
            </div>
        );
    }
}

const stateToProps = (state: IEditorState) => ({
    hasUnsavedChanges: state.history.hasChanges(),

    metaNode: state.container,
})

export const EditorSaveWidget = connect(stateToProps)(SaveComponent);